import { createStore } from 'vuex'

import auth from '@/stores/auth'
import checkoutEnvelope from '@/stores/checkout.envelope'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},

  modules: {
    auth,
    checkoutEnvelope
  }
})
